import { type Editor, Transforms as SlateTransforms } from 'slate';

// @ts-expect-error Missing types
import { htmlToSlate, textToSlate } from 'src/components/RichSlate'; // TODO: consider moving this to global scope

import { createSlateRange } from './queries';
import { placeCursorAtEnd } from './selection';
import type { EditorTextChange, SlateValue } from './types';

/**
 * Apply text changes to the Slate editor
 * @param editor - Slate editor instance
 * @param changes - Text changes
 */
export const applyEditorTextChanges = (editor: Editor, changes: EditorTextChange[]): void => {
  changes.forEach((change) => {
    if (!change?.oldText || !change?.newText) {
      return;
    }

    const endIndex =
      change.endIndex != null ? change.endIndex : change.startIndex + change.oldText.length;
    const range = createSlateRange(editor, change.startIndex, endIndex);
    if (!range) {
      return;
    }

    SlateTransforms.insertText(editor, change.newText, {
      at: range,
    });
  });
};

export const replaceSlateEditorValue = (editor: Editor, newEditorValue: SlateValue): void => {
  if (!editor) {
    return;
  }

  // Remove selection, in order to mitigate "can't find node" errors
  SlateTransforms.deselect(editor);

  // Remove existing nodes
  const children = [...editor.children];
  children.forEach((node) => editor.apply({ type: 'remove_node', path: [0], node }));

  // Add new nodes
  SlateTransforms.insertNodes(editor, newEditorValue);

  placeCursorAtEnd(editor);
};

export const replaceSlateEditorText = (editor: Editor, newTextValue: string): void => {
  if (!editor || newTextValue == null) {
    return;
  }

  const newValue = textToSlate(newTextValue);
  replaceSlateEditorValue(editor, newValue);
};

export const replaceSlateEditorHtml = (editor: Editor, newHtmlValue: string): void => {
  if (!editor || newHtmlValue == null) {
    return;
  }

  const newValue = htmlToSlate(newHtmlValue);
  replaceSlateEditorValue(editor, newValue);
};
